import React from 'react';

const YearHeader = ({ children }) => (
    <th colSpan={3}>
        <div className="d-flex justify-content-center">
            <h5 className="mb-0 text-strong">{children}</h5>
        </div>
    </th>
);

const SubHeader = () => (
    <thead>
        <tr>
            {Array.from({ length: 3 }).map((_, yearIndex) => (
                <React.Fragment key={yearIndex}>
                    <th className="text-center text-strong" style={{ minWidth: 85 }}>
                        Head Count
                    </th>
                    <th className="text-center text-strong" style={{ minWidth: 85 }}>
                        FTE
                    </th>
                    <th className="text-center text-strong" style={{ minWidth: 85 }}>
                        Degrees
                    </th>
                </React.Fragment>
            ))}
        </tr>
    </thead>
);

const Cell = ({ children }) => <td className="text-center text-strong">{children}</td>;

export const EnrollmentHistoryCard = ({ isLoading, years }) => (
    <div className="card p-3 mb-3">
        <h5 className="text-strong mb-3">Enrollment & Degree History</h5>
        <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover align-middle">
                <thead>
                    <tr>
                        {isLoading
                            ? Array.from({ length: 3 }).map((_, i) => (
                                <YearHeader key={i}>Loading Data...</YearHeader>
                            ))
                            : years.map((year, i) => <YearHeader key={i}>{year.label}</YearHeader>)}
                    </tr>
                </thead>
                <SubHeader />
                {!isLoading && (
                    <tbody>
                        <tr>
                            {years.map((year, i) => (
                                <React.Fragment key={i}>
                                    <Cell>{year.headCount}</Cell>
                                    <Cell>{year.fte}</Cell>
                                    <Cell>{year.degrees}</Cell>
                                </React.Fragment>
                            ))}
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    </div>
);
